// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { GLYPH_VIEWBOX, GLYPH_STROKE } from './glyph';
import type { SymbolGlyphProps } from './glyph';

/**
 * The fallback, and the reason nothing on this diagram can go unrendered.
 *
 * A plain box: exactly what every asset was drawn as before the symbol layer
 * existed. Both an unmapped entity type and a symbol we have deliberately not
 * built (`transformer`, `transfer-switch`, `rack`, `protection` — no published
 * instances) resolve here, so the drawing stays whole and no branch anywhere
 * has to say "unsupported".
 */
export const ChipSymbol = ({ size = 18 }: SymbolGlyphProps) => (
  <svg
    width={size}
    height={size}
    viewBox={GLYPH_VIEWBOX}
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="3.5"
      y="7"
      width="17"
      height="10"
      rx="1"
      stroke="currentColor"
      strokeWidth={GLYPH_STROKE}
    />
  </svg>
);
